import { marketAsyncComponent } from '@/utils/asyncComponent';

const com = marketAsyncComponent('vm-select-business-popper', '0.0.1', { crossorigin: 'anonymous' });

// window.Vue.directive('businessSelect', com.createDirective('VmSelectBusinessPopper'));
export default com;
